document.addEventListener('DOMContentLoaded', function () {

  /* ============ TOAST ============ */
  const toast = document.getElementById('toast');
  let toastTimer;
  function showToast(msg) {
    if (!toast) return;
    const msgEl = document.getElementById('toastMsg');
    if (msgEl) msgEl.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('show'), 2600);
  }

  /* ============ WISHLIST (localStorage) ============ */
  let wishlist = JSON.parse(localStorage.getItem('zh_wishlist') || '[]');
  const wishCount = document.getElementById('wishCount');
  function refreshWishUI() {
    if (wishCount) wishCount.textContent = wishlist.length;
    document.querySelectorAll('.prod-wish').forEach(btn => {
      btn.classList.toggle('active', wishlist.includes(btn.dataset.id));
    });
  }
  document.body.addEventListener('click', e => {
    const wb = e.target.closest('.prod-wish');
    if (!wb) return;
    const id = wb.dataset.id;
    if (wishlist.includes(id)) wishlist = wishlist.filter(x => x !== id);
    else wishlist.push(id);
    localStorage.setItem('zh_wishlist', JSON.stringify(wishlist));
    refreshWishUI();
  });
  refreshWishUI();

  /* ============ CARRITO (Shopify AJAX Cart API) ============ */
  const cartCountEl = document.getElementById('cartCount');
  const cartItemsEl = document.getElementById('cartItems');
  const cartTotalEl = document.getElementById('cartTotal');
  const cartDrawer = document.getElementById('cartDrawer');
  const overlayBg = document.getElementById('overlayBg');

  function moneyFmt(cents) {
    return (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function openCart() { if (cartDrawer) cartDrawer.classList.add('open'); if (overlayBg) overlayBg.classList.add('show'); }
  function closeCart() { if (cartDrawer) cartDrawer.classList.remove('open'); if (overlayBg) overlayBg.classList.remove('show'); }

  function renderCart(cart) {
    if (!cartItemsEl) return;
    if (cartCountEl) cartCountEl.textContent = cart.item_count;
    if (cart.item_count === 0) {
      cartItemsEl.innerHTML = `<div class="cart-empty">
        <svg viewBox="0 0 24 24"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.6 13.4a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6L23 6H6"/></svg>
        <div>Tu carrito está vacío</div>
      </div>`;
      if (cartTotalEl) cartTotalEl.textContent = moneyFmt(0);
      return;
    }
    cartItemsEl.innerHTML = cart.items.map((item, idx) => `
      <div class="cart-item">
        <img src="${item.image}" alt="${item.product_title}">
        <div class="ci-info">
          <div class="ci-name">${item.product_title}</div>
          <div class="ci-price">${moneyFmt(item.final_price)}</div>
          <div class="ci-qty">
            <button data-act="dec" data-key="${item.key}" data-qty="${item.quantity - 1}" type="button">−</button>
            <span>${item.quantity}</span>
            <button data-act="inc" data-key="${item.key}" data-qty="${item.quantity + 1}" type="button">+</button>
          </div>
        </div>
        <div class="ci-remove" data-act="del" data-key="${item.key}">Quitar</div>
      </div>`).join('');
    if (cartTotalEl) cartTotalEl.textContent = moneyFmt(cart.total_price);
  }

  function fetchCart() {
    fetch('/cart.js').then(r => r.json()).then(renderCart);
  }

  function addToCart(variantId, name) {
    if (!variantId) { showToast('Este producto no está disponible'); return; }
    fetch(window.routes.cartAddUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(r => r.json())
      .then(() => { fetchCart(); showToast(`${name} añadido al carrito`); })
      .catch(() => showToast('No se pudo añadir el producto'));
  }

  function changeQty(key, quantity) {
    fetch(window.routes.cartChangeUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    }).then(r => r.json()).then(renderCart);
  }

  document.body.addEventListener('click', e => {
    const addBtn = e.target.closest('.add-cart-btn');
    if (addBtn) { addToCart(addBtn.dataset.variantId, addBtn.dataset.name); }
  });

  if (cartItemsEl) {
    cartItemsEl.addEventListener('click', e => {
      const btn = e.target.closest('[data-act]');
      if (!btn) return;
      if (btn.dataset.act === 'inc' || btn.dataset.act === 'dec') changeQty(btn.dataset.key, Number(btn.dataset.qty));
      if (btn.dataset.act === 'del') changeQty(btn.dataset.key, 0);
    });
  }

  const cartBtn = document.getElementById('cartBtn');
  const closeCartBtn = document.getElementById('closeCart');
  if (cartBtn) cartBtn.addEventListener('click', () => { fetchCart(); openCart(); });
  if (closeCartBtn) closeCartBtn.addEventListener('click', closeCart);
  if (overlayBg) overlayBg.addEventListener('click', closeCart);

  /* ============ FILTRO DE PRODUCTOS (tabs) ============ */
  const tabs = document.getElementById('tabs');
  if (tabs) {
    tabs.addEventListener('click', e => {
      const btn = e.target.closest('.tab-btn');
      if (!btn) return;
      tabs.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const filter = btn.dataset.filter;
      document.querySelectorAll('#prodGrid .prod-card').forEach(card => {
        const tags = (card.dataset.tags || '');
        const show = filter === 'todos' || tags.includes(filter);
        card.style.display = show ? '' : 'none';
      });
    });
  }

  /* ============ HERO SLIDER ============ */
  const slides = document.querySelectorAll('.hero-slide');
  const dotsWrap = document.getElementById('heroDots');
  let heroIdx = 0, heroTimer;
  if (slides.length && dotsWrap) {
    slides.forEach((_, i) => {
      const d = document.createElement('button');
      if (i === 0) d.classList.add('active');
      d.type = 'button';
      d.addEventListener('click', () => goHero(i));
      dotsWrap.appendChild(d);
    });
    function goHero(i) {
      slides[heroIdx].classList.remove('active');
      dotsWrap.children[heroIdx].classList.remove('active');
      heroIdx = (i + slides.length) % slides.length;
      slides[heroIdx].classList.add('active');
      dotsWrap.children[heroIdx].classList.add('active');
      resetHeroTimer();
    }
    function resetHeroTimer() { clearInterval(heroTimer); heroTimer = setInterval(() => goHero(heroIdx + 1), 5500); }
    const prevBtn = document.getElementById('heroPrev');
    const nextBtn = document.getElementById('heroNext');
    if (prevBtn) prevBtn.addEventListener('click', () => goHero(heroIdx - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goHero(heroIdx + 1));
    resetHeroTimer();
  }

  /* ============ TESTIMONIOS SLIDER ============ */
  const testSlides = document.querySelectorAll('.test-slide');
  const testDots = document.getElementById('testDots');
  let testIdx = 0;
  if (testSlides.length && testDots) {
    testSlides.forEach((_, i) => {
      const d = document.createElement('button');
      if (i === 0) d.classList.add('active');
      d.type = 'button';
      d.addEventListener('click', () => goTest(i));
      testDots.appendChild(d);
    });
    function goTest(i) {
      testSlides[testIdx].classList.remove('active');
      testDots.children[testIdx].classList.remove('active');
      testIdx = (i + testSlides.length) % testSlides.length;
      testSlides[testIdx].classList.add('active');
      testDots.children[testIdx].classList.add('active');
    }
    setInterval(() => goTest(testIdx + 1), 6000);
  }

  /* ============ MENÚ MÓVIL ============ */
  const burger = document.getElementById('burger');
  const mainNav = document.getElementById('mainNav');
  if (burger && mainNav) {
    burger.addEventListener('click', () => {
      mainNav.classList.toggle('open');
      burger.classList.toggle('open');
    });
    mainNav.querySelectorAll('a').forEach(a => a.addEventListener('click', () => mainNav.classList.remove('open')));
  }

  /* ============ BUSCADOR ============ */
  const searchBox = document.getElementById('searchBox');
  const searchToggle = document.getElementById('searchToggle');
  if (searchBox && searchToggle) {
    searchToggle.addEventListener('click', e => {
      if (!searchBox.classList.contains('open')) {
        e.preventDefault();
        searchBox.classList.add('open');
        searchBox.querySelector('input').focus();
      }
    });
  }

  /* ============ HEADER SCROLL + BACK TO TOP + REVEAL ============ */
  const headerEl = document.getElementById('siteHeader');
  const totop = document.getElementById('totop');
  window.addEventListener('scroll', () => {
    if (headerEl) headerEl.classList.toggle('scrolled', window.scrollY > 10);
    if (totop) totop.classList.toggle('show', window.scrollY > 500);
  });
  if (totop) totop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));

  const observer = new IntersectionObserver(entries => {
    entries.forEach(en => { if (en.isIntersecting) en.target.classList.add('in'); });
  }, { threshold: .15 });
  document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

  /* ============ INIT ============ */
  fetchCart();
});
